import { useState, useEffect, useRef } from 'react'
import { useLocation, Link, useNavigate } from 'react-router-dom'
// ------ Services ------ //
import * as badgeService from '../../../services/badgeManagementService'
import * as clientEventService from '../../../services/clientEventService'
import styles from './FlatTemplateSetup.module.css'
// components - form
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import LoadingSpinner from '../../../components/Miscellaneous/LoadingSpinner'
const FlatTemplateSetup = ({ user }) => {
    const location = useLocation()
    const passedState = location.state
    // state
    const [formData, setFormData] = useState([
        {
            id: null,
            active: false,
            templateName: null,
            templateString: null,
            testData: '',
            testBadge: null,
        }])
    const navigate = useNavigate()
    const [message, setMessage] = useState([''])
    const [loaded, setLoaded] = useState(false)
    const [clientEventInfo, setClientEventInfo] = useState({})
    const clientEventInfoRef = useRef(null);
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current = passedData
        }
    }
    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])

    // --- REST --- //
    const createRequestBody = async () => {
        let requestBody = {}
        if (clientEventInfo.clientId && clientEventInfo.eventId) {
            requestBody =
            {
                "clientId": `${clientEventInfo.clientId}`,
                "eventId": `${clientEventInfo.eventId}`
            }
        }
        return await requestBody;
    }

    /* -------- Functions -------- */
    const fetchFlatTemplateSetup = async () => {
        const getReqBody = await createRequestBody()
        const data = await badgeService.getFlatTemplateSetup(getReqBody)
        if (data && data !== undefined) {
            if(!data.templateString || data.templateString===undefined) {
            data.templateString = JSON.stringify('<!DOCTYPE html>\r\n<html lang="en">\r\n<head>\r\n    <meta charset="utf-8">\r\n    <meta name="viewport" content="width=device-width, ' +
                    'initial-scale=1.0">\r\n    <style type="text/css">\r\n        ' +
                    '.setupHolder {\r\n            height: 1200px;\r\n            position: relative;\r\n        }\r\n        .setup {\r\n            margin-top: 280px;\r\n    ' +
                    '        line-height: 1;\r\n            width: 500px;\r\n            text-align: center;\r\n            height: 400px;\r\n            display: table;\r\n   ' +
                    '     }\r\n        .setupUpsideDown {\r\n            margin-bottom: 375px;\r\n            line-height: 1;\r\n            width: 500px;\r\n    ' +
                    '        text-align: center;\r\n            height: 300px;\r\n            display: table;\r\n            /* Cross-browser rotation */\r\n     ' +
                    '       -moz-transform: scale(-1, -1);\r\n            -webkit-transform: scale(-1, -1);\r\n            -o-transform: scale(-1, -1);\r\n      ' +
                    '      -ms-transform: scale(-1, -1);\r\n            transform: scale(-1, -1);\r\n            position: absolute;\r\n      ' +
                    '      bottom: 0;\r\n        }\r\n        .wrapper {\r\n            position: relative;\r\n            vertical-align: middle;\r\n    ' +
                    '        display: table-cell;\r\n        }\r\n        .wrapper-inner {\r\n            margin: auto;\r\n            width: 440px;\r\n        }\r\n    ' +
                    '    .name { font-size: 75px; font-weight: bold; margin: 20px 0 2px; text-transform: uppercase; }\r\n   ' +
                    '     .nameSmaller { font-size: 60px; font-weight: bold; margin: 20px 0 2px; text-transform: uppercase; }\r\n    ' +
                    '    .lastname { font-size: 60px; margin-bottom: 2px; text-transform: uppercase; }\r\n     ' +
                    '   .lastnameSmaller { font-size: 30px; margin-bottom: 2px; text-transform: uppercase; }\r\n     ' +
                    '   .organization { font-size: 34px; margin: 10px 0 5px; line-height: .9; }\r\n    ' +
                    '    .organizationSmaller { font-size: 24px; margin: 10px 0 5px; line-height: .9; }\r\n    ' +
                    '.city { font-size: 18px; margin-bottom: 2px; }\r\n    </style>\r\n</head>\r\n<body>\r\n    <div id="badges-container"></div>\r\n    <script>\r\n    ' +
                    '/* 1. DATA INJECTION \r\n         In production, your backend will replace %ATTENDEEINFO% with a JSON array string.*/\r\n        \r\n\r\n        \r\n   ' +
                'const attendees = "%ATTENDEEINFO%";\r\n\r\n/ * 2. BADGE GENERATOR FUNCTION * /\r\nfunction generateBadgeHTML(person, counter) {\r\nconst regId =' +
                ' person.LocalRegistrationId ? person.LocalRegistrationId.toString()|| "" : ""\r\n' +
                    'const fName = person.FirstName || "";\r\n            const lName = person.LastName || "";\r\n            const org = person.Organization || "";\r\n      ' +
                    'const cityState = person.CityState_Combo || "";\r\n            \r\n            /* Determine classes based on character length limits */\r\n   ' +
                    'const fNameClass = fName.length > 20 ? "nameSmaller" : "name";\r\n            const lNameClass = lName.length > 20 ? "lastnameSmaller" : "lastname";\r\n ' +
                    'const orgClass = org.length > 20 ? "organizationSmaller" : "organization";\r\n            \r\n            / * Build the badge front content * /\r\n   ' +
                    '         let badgeContent = `\r\n                <div class="wrapper">\r\n                    <div class="wrapper-inner">\r\n                  ' +
                    '      <div class="${fNameClass}">${fName}</div>\r\n <div class="${lNameClass}" > ${lName}</div>\r\n <div class="${orgClass}"> ${org}</div>\r\n' +
                    ' <div class="city" > ${ cityState }</div>`;\r\nif(regId.length > 4) {\r\nbadgeContent += `<img alt="barcode" src="../Kiosk/RenderBarcode?content=${regId }&height=50&width=300" />`;\r\n}' +
                    '\r\nbadgeContent +=`</div>\r\n</div>\r\n`;\r\n\r\n     ' +
                    '       /* Return the full HTML structure for a single physical sheet*/\r\n            if(counter % 2 == 0){\r\n                return `\r\n <div class="setupHolder" >' +
                    '\r\n <div class="setup" >\r\n                        ${ badgeContent } \r\n                    </div>\r\n <div class="setupUpsideDown" ></div>\r\n        ' +
                    '        </div>\r\n            `;\r\n            } else {\r\n                return `\r\n <div class="page-break" ></div>\r\n <div style = "height:1px;" ></div>\r\n' +
                    ' <div class="setupHolder" >\r\n <div class="setup" >\r\n                        ${badgeContent} \r\n                 ' +
                    '   </div>\r\n <div class="setupUpsideDown" ></div>\r\n                </div>\r\n            `;\r\n            }\r\n        }\r\nfunction generateGuestBadgeHTML(person) {\r\n  ' +
                    '          const fName = person.FirstName || "";\r\n            const lName = person.LastName || "";\r\n            const org = person.Organization || "";\r\n       ' +
                    '     const cityState = person.CityState_Combo || "";\r\n            \r\n            const fNameClass = fName.length > 20 ? "nameSmaller" : "name";\r\n      ' +
                    '      const lNameClass = lName.length > 20 ? "lastnameSmaller" : "lastname";\r\n            const orgClass = org.length > 20 ? "organizationSmaller" : "organization";\r\n            \r\n      ' +
                    '      const badgeContent = `\r\n <div class="wrapper" >\r\n <div class="wrapper-inner" >\r\n <div class="${fNameClass}" > ${ fName }</div>\r\n <div class="${lNameClass}" > ${ lName }</div>\r\n' +
                    ' <div class="${orgClass}" > ${ org }</div>\r\n <div class="city" > ${ cityState }</div>\r\n                    </div>\r\n                </div>\r\n            `;\r\n            \r\n      ' +
                    '      return `\r\n <div class="page-break" ></div>\r\n <div style = "height:1px;" ></div>\r\n <div class="setupHolder" >\r\n <div class="setup" >\r\n                    ${ badgeContent } \r\n       ' +
                    '         </div>\r\n <div class="setupUpsideDown" ></div>\r\n            </div>\r\n            `;\r\n        }\r\n\r\n       /* 3. INITIALIZATION LOOP */\r\n        function renderAllBadges() {\r\n    ' +
                    '        const container = document.getElementById("badges-container");\r\n            let finalHTML = "";\r\n            let counter = 0;\r\n            \r\n     ' +
                    '       /* Fixed: Added JSON.parse() so JavaScript loops through an actual array, not a string */\r\n            const parsedAttendees = JSON.parse(attendees);\r\n\r\n\r\n    ' +
                    '       parsedAttendees.forEach(attendee => {\r\n                finalHTML += generateBadgeHTML(attendee, counter);\r\n                counter++;                \r\n          ' +
                    '      const guests = attendee.Guests || "";\r\n                if(guests){\r\n                    guests.forEach(guest => {\r\n                        finalHTML += generateGuestBadgeHTML(guest);\r\n      ' +
                    '              });                }\r\n            });\r\n            \r\n            container.innerHTML = finalHTML;\r\n        }\r\n\r\n        /* Run the script as soon as the window loads*/\r\n   ' +
                    '     window.onload = renderAllBadges;\r\n    </script>\r\n</body>\r\n</html>\r\n');
            }
            setFormData(data)
            GeneratePreview()
        }
        setLoaded(true)
    }
    // useEffect - placeholder fetch function until controller & backend func is created
    useEffect(() => {
        if (clientEventInfo && clientEventInfo.clientId !== undefined && clientEventInfo.clientName) {
            fetchFlatTemplateSetup()
        }

    }, [clientEventInfo])
    
    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }
    }, [])

    const handleChange = (e) => {
        if (e.target.type === 'checkbox') {
            setFormData({
                ...formData,
                [e.target.name]: e.target.checked,
            })
            formData.active = !formData.active
        }
        else if (e.target.name === 'testData' || e.target.name === 'templateString') {
            let stringHolder = JSON.stringify(e.target.value);
            setFormData({
                ...formData,
                [e.target.name]: stringHolder,
            })
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
        }
    }

    const isFormInvalid = () => {
        return (formData.templateName && formData.templateString && formData.testData)
    }

    const handlePreview = async e => {
        e.preventDefault()
        GeneratePreview()
    }
    const GeneratePreview = () => {
        if (formData.templateString !== undefined && formData.testData !== undefined) {
            let newHTML = JSON.parse(formData.templateString).replace("\"%ATTENDEEINFO%\"", `${formData.testData}`);
            setFormData({
                ...formData,
                ['testBadge']: newHTML,
            })
        }
    }
    const handleSubmit = async e => {
        e.preventDefault()
        let saverequest =  {
            ...formData
        };
        try {
            await badgeService.saveFlatTemplateSetup(saverequest)
            const newClientEvent = {
                clientId: clientEventInfo.clientId,
                eventId: clientEventInfo.eventId,
                clientName: clientEventInfo.clientName,
                eventName: clientEventInfo.eventName,
                useFlatSetup: formData.active,
            }
            clientEventService.setClientEvent(newClientEvent)
            setMessage('Save Successful');
        } catch (err) {
            setMessage(err.message)
        }
    }
    // Print � opens the full badge HTML document in a new window and prints it.
    // react-to-print cannot print an iframe's srcDoc content (it clones the
    // outer iframe DOM node, not the document inside it). Using window.open()
    // is the correct approach when the print target is a complete HTML string.
    const handlePrint = () => {
        if (!formData.testBadge) return
        const printWindow = window.open('', '_blank')
        printWindow.document.open()
        printWindow.document.write(formData.testBadge)
        printWindow.document.close()
        // Allow the badge template's window.onload script to run and
        // populate the badges-container before triggering the print dialog.
        setTimeout(() => {
            printWindow.focus()
            printWindow.print()
            printWindow.close()
        }, 500)
    }
    return (
        <>
            {
                loaded ?
                    <div className="page-area">
                        <h1>Event Flat Template Setup</h1>
                        <button className={styles.backButton} onClick={() => navigate(-1)}> Back </button>
                        <div className={styles.container}>
                            
                            <div className={styles.leftPane}>
                                <form onSubmit={handleSubmit}>
                                    <h2>Flat Template Settings</h2>
                                    <br /><br />
                                    {
                                        message ?
                                            <h3 style={{ color: 'green' }}>{message}</h3> :
                                            <></>
                                    }
                                    <br /><br />
                                    <div>
                                        <label
                                            htmlFor="active"
                                            className={styles.label}
                                        >
                                            Active
                                            <HoverButton
                                                title={'Control usage of setup\ntrue: use setup\nfalse: do not use setup'}
                                                messageWidth={350}
                                            />
                                            :
                                        </label>
                                        <input className={styles.input}
                                            type="checkbox"
                                            value={formData.active}
                                            checked={formData.active}
                                            name="active"
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div >
                                        <label
                                            htmlFor="templateName"
                                            className={styles.label}
                                        >
                                            Template Name
                                            <HoverButton
                                                title={'Template Name - used for quick finding/reference.'}
                                                messageWidth={350}
                                            />
                                            :<br />
                                            <input
                                                type="text"
                                                value={formData.templateName}
                                                name="templateName"
                                                className={styles.inputContainerSmaller}
                                                onChange={handleChange}
                                            />
                                        </label>
                                        
                                    </div>
                                    <div className={styles.containerSmaller}>
                                        <button disabled={!isFormInvalid()} onClick={handlePreview} className={styles.leftButton}>
                                            Preview
                                        </button>
                                        <button disabled={!isFormInvalid()} className={styles.rightButton} onClick={handleSubmit}>
                                            Save
                                        </button>
                                    </div>
                                    {formData.testData && formData.testData !== undefined ?
                                        <div >
                                            <label
                                                htmlFor="testData"
                                                className={styles.label}
                                            >
                                                Test Data String
                                                <HoverButton
                                                    title={'Test Data String - string of data used in testing the template.'}
                                                    messageWidth={350}
                                                />
                                                :<br />
                                                <textarea
                                                    spellCheck="false"
                                                    autoCorrect="off"
                                                    autoCapitalize="off"
                                                    data-gramm="false"
                                                    data-gramm_editor="false"
                                                    data-enable-grammarly="false"
                                                    autoComplete="off"
                                                    value={JSON.parse(formData.testData)}
                                                    name="testData"
                                                    rows="30"
                                                    onChange={handleChange}
                                                />
                                            </label>

                                        </div>
                                    :
                                    <div>Franky data not Found. Check that registrants loaded.</div>
                                    }
                                    {formData.templateString && formData.templateString !== undefined ?
                                    <div >
                                        <label
                                            htmlFor="templateString"
                                            className={styles.label}
                                        >
                                            Template String
                                            <HoverButton
                                                title={'Template String - string used in generating the template.'}
                                                messageWidth={350}
                                            />
                                            :<br />
                                            <textarea
                                                spellCheck="false"
                                                autoCorrect="off"
                                                autoCapitalize="off"
                                                data-gramm="false"
                                                data-gramm_editor="false"
                                                data-enable-grammarly="false"
                                                autoComplete="off"
                                                value={JSON.parse(formData.templateString)}
                                                    name="templateString"
                                                    rows="60"
                                                    onChange={handleChange}
                                            />
                                        </label>
                                        
                                    </div>
                                        :
                                        <></>
                                    }
                                    <div className={styles.containerSmaller}>
                                        <button disabled={!isFormInvalid()} onClick={handlePreview} className={styles.leftButton}>
                                            Preview
                                        </button>
                                        <button disabled={!isFormInvalid()} className={styles.rightButton} onClick={handleSubmit}>
                                            Save
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <div className={styles.rightPane}>
                                {formData.testBadge && formData.testBadge !== undefined ?
                                    <>
                                        <div className={styles.inputContainer}>
                                            <button disabled={!isFormInvalid()} className={styles.button} onClick={handlePrint}>
                                                Print
                                            </button>
                                        </div>
                                        <div className="app-container" style={{ height: '1400px', width: '100%' }}>
                                            <iframe srcDoc={formData.testBadge} title="Badge Content Preview" id='iframeBadge'
                                                sandbox="allow-scripts allow-modals"
                                                style={{ width: '100%', height: '100%', border: '1px solid #ccc' }}
                                            />
                                        </div>
                                        <br />
                                        <div className={styles.inputContainer}>
                                            <button disabled={!isFormInvalid()} className={styles.button} onClick={handlePrint}>
                                                Print
                                            </button>
                                        </div>
                                    </>
                                    
                                : <>
                                    </>}
                                
                            </div>
                        </div>
                    </div>
                    :
                    <LoadingSpinner />
            }
        </>
    )
}

export default FlatTemplateSetup;